export function humanReadableFileSize(bytes: unknown, binary: boolean = false): string {
    if (typeof bytes !== 'number' || isNaN(bytes) || bytes < 0) {
        return '0 B'; // Ensure valid input and prevent negative values
    }

    const base = binary ? 1024 : 1000;

    if (bytes < base) {
        return `${bytes} B`;
    }

    const units = binary
        ? ['Ki', 'Mi', 'Gi', 'Ti', 'Pi', 'Ei']
        : ['k', 'M', 'G', 'T', 'P', 'E'];

    let unitIndex = -1;

    while (bytes >= base && unitIndex < units.length - 1) {
        bytes /= base;
        unitIndex++;
    }

    return `${bytes.toFixed(1)} ${units[unitIndex]}B`;
}
